import React, { useEffect, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { Helmet } from 'react-helmet';
import { useHistory, useLocation } from 'react-router-dom';

import {
  UI_OPERATION_STATUS_SUCCESS,
  UI_OPERATION_STATUS_ERROR,
  setOperationStatus,
  commerceCartCheckout,
} from '@uncinc/react-drupal-core';

import { Container, Button } from '@uncinc/uncinc-react-kitchen-sink';

import CartProducts from './Checkout/CartProducts/index';
import { DEFAULT_LANGUAGE } from '../../config/constants';
import CartSummary from './CartSummary';
import { formatCartItemsForAnalytics } from '../../helpers/commerce';
import { clearPageInformation, setPageInformation, setPageViewSent } from '../../store/actions/UI';

import './style.scss';


const Cart = () => {
  const PAGE_TITLE = 'Winkelwagen | VeiligheidNL';
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const history = useHistory();
  const checkoutStatus = useSelector((state) => state.getIn(['ui', 'commerce', 'operations', 'cart_checkout', 'status']));
  const loggedIn = useSelector((state) => state.getIn(['login', 'loggedIn'], false));
  const commerce = useSelector((state) => state.get('commerce'));
  const totalNet = commerce.getIn(['cart', 'content', 'attributes', 'order_total', 'subtotal', 'formatted']);
  const totalPrice = commerce.getIn(['cart', 'content', 'attributes', 'order_total', 'subtotal', 'number']);

  const analyticsItems = useMemo(() => {
    return formatCartItemsForAnalytics(commerce.getIn(['cart', 'products']));
  }, [commerce]);

  useEffect(() => {
    dispatch(clearPageInformation());
    dispatch(setPageInformation(PAGE_TITLE));
    dispatch(setPageViewSent(false));
  }, []);

  useEffect(() => {
    if (checkoutStatus === UI_OPERATION_STATUS_SUCCESS) {
      history.push('/cart/checkout');
      dispatch(setOperationStatus('commerce', 'cart_checkout', null));
    } else if (checkoutStatus === UI_OPERATION_STATUS_ERROR) {
      dispatch(setOperationStatus('commerce', 'cart_checkout', null));
    }
  }, [dispatch, history, checkoutStatus]);

  const checkout = () => {
    if (typeof window !== 'undefined') {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: 'begin_checkout',
        ecommerce: {
          currency: 'EUR',
          value: totalPrice,
          items: analyticsItems,
        },
      });
    }

    if (loggedIn) {
      if (typeof window !== 'undefined') {
        window.dataLayer.push({
          event: 'add_shipping_info',
          ecommerce: {
            currency: 'EUR',
            value: totalPrice,
            items: analyticsItems,
          },
        });
      }
      dispatch(commerceCartCheckout());
    } else {
      history.push('/cart/checkout/login-or-register');
    }
  };

  return (
    <>
      <Helmet
        htmlAttributes={{
          lang: DEFAULT_LANGUAGE,
        }}
      >
        <title>{PAGE_TITLE}</title>
      </Helmet>
      <Container>
        <div className="Cart__backToPage" onClick={() => history.goBack()}>
          <div className="icon icon-chevron-right" />
          {t('cart.back_to_webpage')}
        </div>
        <div className="Cart__container" id="main">
          <div className="Cart__content">
            <h3 className="Cart__title">{t('cart.your_cart')}</h3>
            <CartProducts readOnly={false} />
          </div>
          <div className="CartSummary">
            <div className="CartSummary__wrapper">
              <div className="CartSummary__title"><strong>{t('cart.your_order')}</strong></div>
              <CartSummary />
              <Button onClick={() => checkout()} disabled={!totalNet} className="Button Button--primary">{t('cart.i_order')}</Button>
            </div>
          </div>
        </div>
      </Container>
    </>
  );
};

export default Cart;
